module.exports = "<!-- Tags is basically just a wrapper around Word List Input-->\r\n<app-word-list-input\r\n    [items]=\"tags\"\r\n    itemName=\"Tag\"\r\n    [contextClass]=\"contextClass\"\r\n    [typeaheadWords]=\"savedTags\"\r\n    (updated)=\"updateTags($event)\">\r\n</app-word-list-input>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/shared-module/widgets/tags/tags.component.html
// module id = ../../../../../src/app/shared-module/widgets/tags/tags.component.html
// module chunks = main